import { useEffect } from "react";
import { useBreadcrumbs } from "@/context/BreadcrumbContext";
import { Fingerprint } from "lucide-react";
import { LiquidCardShowcase } from "./LiquidCardShowcase";
import { ThetaMark } from "./ThetaMark";
import { SocialProfileEntry } from "./SocialProfileEntry";
import "./LandingPage.css";

export function PublicDocumentPage({ path }: { path: string }) {
  return <iframe src={path} title="θ legal document" className="fixed inset-0 h-full w-full border-0" />;
}

export function LandingPage() {
  const { setBreadcrumbs, setDocumentTitleOverride } = useBreadcrumbs();
  useEffect(() => {
    setBreadcrumbs([{ label: "θ" }]);
    setDocumentTitleOverride("\u200B");
    return () => { setBreadcrumbs([]); setDocumentTitleOverride(null); };
  }, [setBreadcrumbs, setDocumentTitleOverride]);

  return (
    <div className="mars-landing">
      <a className="mars-skip-link" href="#mars-main">Skip to content</a>
      <header className="mars-header">
        <a href="/" className="mars-brand" aria-label="θ home"><ThetaMark /></a>
        <nav className="mars-header-actions" aria-label="Get started">
          <a className="mars-demo-link" href="#liquidcards">Try the demo</a>
          <a className="mars-passkey" href="https://otc.network/passkey?section=passkey">
            <Fingerprint size={17} aria-hidden="true" /> Connect Passkey
          </a>
        </nav>
      </header>
      <main id="mars-main" tabIndex={-1}>
        <div className="otc-intro">
          <h1>One passkey.<br />More connections.</h1>
          <p>Order. Tap. Collect. One Passkey.</p>
        </div>
        <LiquidCardShowcase />
        <SocialProfileEntry />
      </main>
      <footer className="mars-footer"><span><ThetaMark /></span><a href="/auth">Pro workspace</a><a href="/privacy">Privacy</a><a href="/terms">Terms</a></footer>
    </div>
  );
}
